var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116.023,
    height: 37.953,
    viewBox: "0 0 116.023 37.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M151.447,339.047l-5.232-3.021L136.124,330.2c-.56-.323-1.118-.128-1.118.548v23.739c0,.507.4.725.886.444l10.324-5.961,5.231-3.02,5.029-2.9c.59-.341.533-.808.036-1.077S151.447,339.047,151.447,339.047Z",
    transform: "translate(-135.006 -330.047)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-pay-linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006aa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#2f8da6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#66b6ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7cc6af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-pay-linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab59d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfe385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-pay-linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4282d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#ba2d4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#83357b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e388d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-pay-linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f07165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#faa460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffba5e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google_play_Icon",
    "data-name": "Google play Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M212.664,328.9a5.129,5.129,0,0,1-5.128,5.129H101.77a5.13,5.13,0,0,1-5.129-5.129V301.2a5.13,5.13,0,0,1,5.129-5.129H207.537a5.129,5.129,0,0,1,5.128,5.129Z",
    transform: "translate(-96.641 -296.074)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PLAY",
    transform: "translate(8.703 7.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M135.006,328.285v25.7l12.96-12.85Z",
    transform: "translate(-135.006 -328.685)",
    fill: "url(#google-pay-linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M151.447,337.366l-5.232-3.02-11.21-6.472v.093l12.96,12.851Z",
    transform: "translate(-135.006 -328.366)",
    fill: "url(#google-pay-linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M135.006,397.788v.093l11.21-6.472,5.231-3.02-3.481-3.451Z",
    transform: "translate(-135.006 -372.486)",
    fill: "url(#google-pay-linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M195.621,369.721l-3.481,3.452,3.481,3.451,5.979-3.452Z",
    transform: "translate(-179.179 -360.721)",
    fill: "url(#google-pay-linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336",
    transform: "translate(86.817 14.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M482.846,380.679a3.232,3.232,0,0,1-1.333-.269,2.513,2.513,0,0,1-1.013-.828h-.082a10.05,10.05,0,0,1,.082,1.241V383.9h-1.131v-10.83h.921l.156,1.023h.054a2.632,2.632,0,0,1,1.017-.886,3.087,3.087,0,0,1,1.329-.273,2.762,2.762,0,0,1,2.295,1.016,5.412,5.412,0,0,1-.013,5.712A2.769,2.769,0,0,1,482.846,380.679Zm-.164-6.786a2.006,2.006,0,0,0-1.657.634,3.266,3.266,0,0,0-.526,2.019v.252a3.739,3.739,0,0,0,.526,2.254,2,2,0,0,0,1.684.678,1.752,1.752,0,0,0,1.518-.784,3.721,3.721,0,0,0,.549-2.162,3.581,3.581,0,0,0-.549-2.145A1.807,1.807,0,0,0,482.682,373.894Z",
    transform: "translate(-479.368 -369.931)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M516.076,370.315h-1.132V359.7h1.132Z",
    transform: "translate(-506.874 -359.703)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M531.053,380.589l-.225-1.064h-.054a3.136,3.136,0,0,1-1.115.951,3.387,3.387,0,0,1-1.388.249,2.5,2.5,0,0,1-1.742-.573,2.088,2.088,0,0,1-.631-1.63q0-2.264,3.621-2.373l1.269-.041v-.463a1.893,1.893,0,0,0-.379-1.3,1.555,1.555,0,0,0-1.21-.42,4.93,4.93,0,0,0-2.114.573l-.348-.866a5.319,5.319,0,0,1,1.211-.47,5.241,5.241,0,0,1,1.32-.171,2.848,2.848,0,0,1,1.981.593,2.479,2.479,0,0,1,.644,1.9v5.1Zm-2.557-.8a2.3,2.3,0,0,0,1.661-.58,2.146,2.146,0,0,0,.6-1.623v-.675l-1.133.047a4.119,4.119,0,0,0-1.947.42,1.265,1.265,0,0,0-.6,1.156,1.165,1.165,0,0,0,.372.934A1.541,1.541,0,0,0,528.5,379.792Z",
    transform: "translate(-515.342 -369.978)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M555.222,373.533h1.213l1.637,4.263a16.294,16.294,0,0,1,.669,2.108h.055q.089-.348.371-1.191t1.851-5.179h1.215l-3.213,8.511a4.246,4.246,0,0,1-1.115,1.791,2.372,2.372,0,0,1-1.565.528,4.582,4.582,0,0,1-1.023-.115v-.907a3.954,3.954,0,0,0,.839.082,1.729,1.729,0,0,0,1.664-1.31l.416-1.064Z",
    transform: "translate(-538.015 -370.396)",
    fill: "#f9f9f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338",
    transform: "translate(35.209 13.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M382.374,374.676a2.546,2.546,0,0,1-.2,4.33,1.1,1.1,0,0,0-.438.767.857.857,0,0,0,.407.672l.563.437a2.722,2.722,0,0,1,1.313,2.19c0,1.469-1.423,2.954-4.111,2.954-2.267,0-3.361-1.078-3.361-2.236a2.249,2.249,0,0,1,1.2-1.907,6.739,6.739,0,0,1,2.986-.72,1.636,1.636,0,0,1-.469-1.062,1.411,1.411,0,0,1,.157-.611c-.173.016-.344.032-.5.032a2.472,2.472,0,0,1-2.595-2.454,2.813,2.813,0,0,1,1-2.1,4.264,4.264,0,0,1,2.8-.86h3.22l-1,.563Zm-1.11,6.942a2.426,2.426,0,0,0-.359-.016,6.255,6.255,0,0,0-1.642.251,1.756,1.756,0,0,0-1.345,1.61c0,1.109,1.079,1.908,2.752,1.908,1.5,0,2.3-.72,2.3-1.689C382.969,382.883,382.453,382.462,381.264,381.618Zm.454-2.971a1.582,1.582,0,0,0,.39-1.142c0-1.125-.672-2.876-1.969-2.876a1.46,1.46,0,0,0-1.095.516,1.806,1.806,0,0,0-.344,1.157c0,1.047.61,2.783,1.955,2.783A1.6,1.6,0,0,0,381.718,378.647Z",
    transform: "translate(-348.259 -370.009)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M345.881,380.611a3.683,3.683,0,0,1-3.808-3.684,3.868,3.868,0,0,1,4.043-3.792,3.649,3.649,0,0,1,3.73,3.683A3.814,3.814,0,0,1,345.881,380.611Zm1.951-1.264a2.824,2.824,0,0,0,.469-1.733c0-1.374-.655-4-2.591-4a2.174,2.174,0,0,0-1.4.531,2.362,2.362,0,0,0-.719,1.9c0,1.544.765,4.087,2.654,4.087A1.994,1.994,0,0,0,347.832,379.347Z",
    transform: "translate(-321.608 -369.252)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M308.585,380.611a3.684,3.684,0,0,1-3.809-3.684,3.868,3.868,0,0,1,4.043-3.792,3.649,3.649,0,0,1,3.73,3.683A3.814,3.814,0,0,1,308.585,380.611Zm1.951-1.264a2.828,2.828,0,0,0,.468-1.733c0-1.374-.656-4-2.591-4a2.175,2.175,0,0,0-1.4.531,2.362,2.362,0,0,0-.718,1.9c0,1.544.764,4.087,2.654,4.087A2,2,0,0,0,310.536,379.347Z",
    transform: "translate(-292.772 -369.252)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M262.668,368.325l-2.244.518a16.632,16.632,0,0,1-2.589.266,5.576,5.576,0,0,1-5.979-5.681c0-3.044,2.338-5.868,6.34-5.868a9.034,9.034,0,0,1,2.4.329,6.118,6.118,0,0,1,2.071.973l-1.3,1.24-.549.125.392-.628a4.485,4.485,0,0,0-3.358-1.474,4.334,4.334,0,0,0-4.347,4.63,5.549,5.549,0,0,0,5.555,5.727,4.674,4.674,0,0,0,1.993-.392v-2.526l-2.369.125,1.255-.676h3.327l-.407.392a.367.367,0,0,0-.157.251c-.016.142-.031.6-.031.754Z",
    transform: "translate(-251.856 -357.21)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M412.754,366.681c-.518-.047-.626-.141-.626-.754v-8.882c0-.034.005-.069.009-.1.063-.549.22-.643.707-.926H410.6l-1.177.565h1.2v9.689c0,.313-.062.361-.423.831h2.778l.58-.344C413.289,366.728,413.021,366.713,412.754,366.681Z",
    transform: "translate(-373.679 -356.019)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M432.878,380.075c-.171.094-.342.2-.513.281a3.629,3.629,0,0,1-1.513.3,3.33,3.33,0,0,1-2.073-.608,4.033,4.033,0,0,1-1.589-3.288,3.532,3.532,0,0,1,3.569-3.6,3.029,3.029,0,0,1,1.606.437,2.58,2.58,0,0,1,1.089,1.542l-3.661,1.481-1.2.093c.389,1.979,1.729,3.132,3.21,3.132a4.027,4.027,0,0,0,1.9-.544Zm-1.464-4.645c.3-.109.451-.2.451-.421a1.546,1.546,0,0,0-1.543-1.34,1.919,1.919,0,0,0-1.792,2.166c0,.265.031.545.047.827Z",
    transform: "translate(-387.418 -369.269)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337",
    transform: "translate(46.5 3.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M457.311,373.263v1.028h-.125v-1.028h-.34v-.107h.805v.107Z",
    transform: "translate(-456.846 -373.156)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M462.155,374.291v-1.038h-.006l-.317,1.038h-.1l-.32-1.038h0v1.038H461.3v-1.135h.194l.289.917h0l.285-.917h.2v1.135Z",
    transform: "translate(-460.288 -373.156)",
    fill: "#f9f9f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339",
    transform: "translate(35.235 7.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M255.064,333.276h-.78a5.174,5.174,0,0,0-.222-.911h-1.126a4.711,4.711,0,0,0-.229.911h-.733q0-.095.569-1.56a12.261,12.261,0,0,0,.569-1.613h.921a13.464,13.464,0,0,0,.515,1.59A13.916,13.916,0,0,1,255.064,333.276Zm-1.126-1.377a13.79,13.79,0,0,1-.417-1.36h-.039q0,.1-.431,1.36Z",
    transform: "translate(-251.974 -330.03)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M270.535,333.276h-.6a5.931,5.931,0,0,0-.67-1.055,5.812,5.812,0,0,1-.8-1.377h-.039a8.589,8.589,0,0,1,.061.965q0,.6.034,1.467h-.6q.037-.755.037-1.66t-.037-1.513h.724a4.585,4.585,0,0,0,.6,1.031,6.068,6.068,0,0,1,.736,1.3h.036a9.258,9.258,0,0,1-.058-.975q0-.66-.034-1.355h.609q-.034.6-.034,1.513T270.535,333.276Z",
    transform: "translate(-264.303 -330.03)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M285.881,331.529a1.8,1.8,0,0,1-.444,1.209,1.549,1.549,0,0,1-1.243.517q-.361,0-.994-.029.032-.736.032-1.66,0-.887-.032-1.513h.426q.1,0,.312-.008t.27-.007a1.643,1.643,0,0,1,1.276.439A1.516,1.516,0,0,1,285.881,331.529Zm-.665.1a1.174,1.174,0,0,0-.273-.788,1.034,1.034,0,0,0-.833-.32,2.581,2.581,0,0,0-.288.022q.024.488.025,1.018,0,.583.024,1.155a1.615,1.615,0,0,0,.317.032.921.921,0,0,0,.776-.326A1.255,1.255,0,0,0,285.215,331.634Z",
    transform: "translate(-276.117 -329.979)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M300.619,333.225H299.9a4.783,4.783,0,0,0-.434-1.065.568.568,0,0,0-.487-.2l-.271,0q0,.626.022,1.265h-.677q.032-.736.032-1.66,0-.887-.032-1.513h.421q.073,0,.306-.008t.43-.007q1.118,0,1.119.765a.858.858,0,0,1-.639.846v.037a.761.761,0,0,1,.431.384A8.485,8.485,0,0,1,300.619,333.225Zm-.914-2.242q0-.485-.624-.485a2.125,2.125,0,0,0-.4.034q.027.378.027.984.134,0,.227,0Q299.705,331.522,299.706,330.983Z",
    transform: "translate(-287.599 -329.979)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M314.2,331.381a1.75,1.75,0,0,1-.458,1.24,1.487,1.487,0,0,1-1.133.492,1.432,1.432,0,0,1-1.077-.452,1.591,1.591,0,0,1-.434-1.149,1.749,1.749,0,0,1,.458-1.24,1.486,1.486,0,0,1,1.133-.492,1.433,1.433,0,0,1,1.077.451A1.59,1.59,0,0,1,314.2,331.381Zm-.672.071a1.258,1.258,0,0,0-.261-.826.8.8,0,0,0-.643-.317.743.743,0,0,0-.6.319,1.274,1.274,0,0,0-.249.806,1.255,1.255,0,0,0,.262.825.8.8,0,0,0,.642.318.742.742,0,0,0,.6-.32A1.275,1.275,0,0,0,313.526,331.452Z",
    transform: "translate(-297.686 -329.78)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M328.495,333.276h-.69q.032-.755.032-1.66T327.8,330.1h.69q-.032.614-.032,1.513Q328.463,332.535,328.495,333.276Z",
    transform: "translate(-310.604 -330.03)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M337.279,331.529a1.8,1.8,0,0,1-.443,1.209,1.549,1.549,0,0,1-1.243.517q-.361,0-.994-.029.032-.736.032-1.66,0-.887-.032-1.513h.426q.1,0,.312-.008t.27-.007a1.643,1.643,0,0,1,1.276.439A1.517,1.517,0,0,1,337.279,331.529Zm-.665.1a1.175,1.175,0,0,0-.273-.788,1.035,1.035,0,0,0-.833-.32,2.576,2.576,0,0,0-.288.022q.024.488.024,1.018,0,.583.024,1.155a1.615,1.615,0,0,0,.317.032.921.921,0,0,0,.776-.326A1.255,1.255,0,0,0,336.614,331.634Z",
    transform: "translate(-315.856 -329.979)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M356.54,333.276h-.78a5.141,5.141,0,0,0-.222-.911h-1.126a4.7,4.7,0,0,0-.229.911h-.733q0-.095.569-1.56a12.237,12.237,0,0,0,.569-1.613h.921a13.44,13.44,0,0,0,.516,1.59A13.979,13.979,0,0,1,356.54,333.276Zm-1.126-1.377a13.848,13.848,0,0,1-.417-1.36h-.039q0,.1-.431,1.36Z",
    transform: "translate(-330.431 -330.03)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M371.711,330.884a.95.95,0,0,1-.433.86,1.924,1.924,0,0,1-1.061.278q-.115,0-.163,0,0,.458.027,1.209H369.4q.032-.7.032-1.66,0-.877-.032-1.513h.424q.09,0,.346-.008t.443-.007a1.394,1.394,0,0,1,.782.21A.709.709,0,0,1,371.711,330.884Zm-.629.134q0-.521-.692-.521a1.95,1.95,0,0,0-.365.036q.027.46.027,1.043c.041,0,.088.005.141.005Q371.082,331.581,371.082,331.017Z",
    transform: "translate(-342.76 -329.979)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M384.595,330.884a.95.95,0,0,1-.432.86,1.926,1.926,0,0,1-1.061.278c-.076,0-.131,0-.163,0q0,.458.027,1.209h-.685q.032-.7.032-1.66,0-.877-.032-1.513h.424q.09,0,.346-.008t.443-.007a1.394,1.394,0,0,1,.782.21A.709.709,0,0,1,384.595,330.884Zm-.629.134q0-.521-.692-.521a1.949,1.949,0,0,0-.365.036q.027.46.027,1.043c.041,0,.088.005.141.005Q383.966,331.581,383.966,331.017Z",
    transform: "translate(-352.722 -329.979)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M402.977,331.381a1.749,1.749,0,0,1-.458,1.24,1.486,1.486,0,0,1-1.133.492,1.432,1.432,0,0,1-1.077-.452,1.592,1.592,0,0,1-.434-1.149,1.75,1.75,0,0,1,.458-1.24,1.487,1.487,0,0,1,1.133-.492,1.433,1.433,0,0,1,1.077.451A1.591,1.591,0,0,1,402.977,331.381Zm-.673.071a1.256,1.256,0,0,0-.261-.826.8.8,0,0,0-.643-.317.743.743,0,0,0-.6.319,1.274,1.274,0,0,0-.248.806,1.255,1.255,0,0,0,.262.825.8.8,0,0,0,.642.318.741.741,0,0,0,.6-.32A1.274,1.274,0,0,0,402.3,331.452Z",
    transform: "translate(-366.325 -329.78)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M419.2,333.276h-.6a5.933,5.933,0,0,0-.67-1.055,5.816,5.816,0,0,1-.8-1.377h-.039a8.636,8.636,0,0,1,.061.965q0,.6.034,1.467h-.6q.036-.755.037-1.66t-.037-1.513h.724a4.593,4.593,0,0,0,.6,1.031,6.067,6.067,0,0,1,.736,1.3h.036a9.2,9.2,0,0,1-.059-.975q0-.66-.034-1.355h.609q-.034.6-.034,1.513T419.2,333.276Z",
    transform: "translate(-379.244 -330.03)",
    fill: "#f7f8f8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayIcon);
export default __webpack_public_path__ + "static/media/google-play-icon.5770e2b84fc91322fe522c7ef1554c73.svg";
export { ForwardRef as ReactComponent };